module.exports = __webpack_public_path__ + "static/media/loupsGarous_03_thumb_hover.e6b4191e.png";